<template>
  <v-app>
    <v-container>
      <v-row>
        <transition name="fade">
          <div v-if="performingRequest" class="loading">
            <p>Loading...</p>
          </div>
        </transition>

        <v-col cols="6" :class="{ 'signup-form': !showLoginForm && !showForgotPassword }">
          <form v-if="showLoginForm" @submit.prevent>
            <h4 class="mb-4">Login</h4>

            <v-text-field label="Email" v-model.trim="loginForm.email" type="text" placeholder="you@email.com"
              id="email1" :color="theme"></v-text-field>

            <v-text-field label="Password" v-model.trim="loginForm.password" type="password" placeholder="******"
              id="password1" :color="theme"></v-text-field>

            <v-btn light :color="theme" @click="login" class="mr-2 mb-2">Login</v-btn>
            <v-btn light class="mb-2" @click="toggleForm" :color="theme">Create an Account</v-btn>

            <div class="extras mt-10">
              <a class="amber--text" @click="togglePasswordReset">Forgot Password</a>
            </div>
          </form>
          <form v-if="!showLoginForm && !showForgotPassword" @submit.prevent>
            <h4 class="mb-4">Create an account</h4>

            <v-text-field label="First name" v-model.trim="signupForm.first" type="text" placeholder="First name"
              id="firstName" :color="theme"></v-text-field>
            <v-text-field label="Last name" v-model.trim="signupForm.last" type="text" placeholder="Last name"
              id="title" color="amber"></v-text-field>
            <v-text-field label="Company" v-model.trim="signupForm.company" type="text" placeholder="Company"
              id="company" :color="theme"></v-text-field>
            <v-text-field label="Role" v-model.trim="signupForm.role" type="text" placeholder="Role" id="role"
              :color="theme"></v-text-field>
            <v-text-field label="Initial" v-model.trim="initial" type="text" id="initial" :color="theme"></v-text-field>
            <v-textarea name="Bio" label="Bio" v-model.trim="signupForm.bio" type="text" placeholder="Short bio"
              id="bio" :color="theme"></v-textarea>

            <v-text-field label="Email" v-model.trim="signupForm.email" type="text" placeholder="you@email.com"
              id="email2" :color="theme"></v-text-field>

            <v-text-field label="Password" v-model.trim="signupForm.password" type="password"
              placeholder="min 6 characters" id="password2" :color="theme"></v-text-field>

            <v-btn light :color="theme" @click="signup">Sign up</v-btn>

            <div class="extras mt-10">
              <a @click="toggleForm" class="amber--text">Back to Log In</a>
            </div>
          </form>
          <form v-if="showForgotPassword" @submit.prevent class="password-reset">
            <div v-if="!passwordResetSuccess">
              <h4 class="mb-4">Reset password</h4>
              <p>We will send you an email to reset your password</p>

              <v-text-field label="Email" v-model.trim="passwordForm.email" type="text" placeholder="you@email.com"
                id="email3" :color="theme"></v-text-field>

              <v-btn small :color="theme" @click="resetPassword">Submit</v-btn>

              <div class="extras">
                <a @click="togglePasswordReset" class="amber--text">Back to Log In</a>
              </div>
            </div>
            <div v-else>
              <h1>Email Sent</h1>
              <p>check your email for a link to reset your password</p>
              <v-btn small :color="theme" @click="togglePasswordReset">Back to login</v-btn>
            </div>
          </form>
          <transition name="fade">
            <div v-if="errorMsg !== ''" class="error-msg">
              <p>{{ errorMsg }}</p>
            </div>
          </transition>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      theme: "amber",
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        first: "",
        last: "",
        initial: "",
        company: "",
        role: "",
        bio: "",
        email: "",
        group: "",
        password: "",
      },
      passwordForm: {
        email: "",
      },
      showLoginForm: true,
      showForgotPassword: false,
      passwordResetSuccess: false,
      performingRequest: false,
      errorMsg: "",
    };
  },
  computed: {
    initial() {
      return `${this.signupForm.first.substr(
        0,
        1
      )}${this.signupForm.last.substr(0, 1)}`;
    },
  },
  methods: {
    toggleForm() {
      this.errorMsg = "";
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      if (this.showForgotPassword) {
        this.showLoginForm = true;
        this.showForgotPassword = false;
        this.passwordResetSuccess = false;
      } else {
        this.showLoginForm = false;
        this.showForgotPassword = true;
      }
    },
    login() {
      this.performingRequest = true;

      fb.auth
        .signInWithEmailAndPassword(
          this.loginForm.email,
          this.loginForm.password
        )
        .then((res) => {
          // signInWithEmailAndPassword resolves with a UserCredential, the user
          // itself (and its uid) is on res.user
          this.$store.commit("setCurrentUser", res.user || fb.auth.currentUser);
          this.$store.dispatch("fetchUserProfile");
          this.performingRequest = false;
          this.$router.push("/users/dashboard");
        })
        .catch((err) => {
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
    signup() {
      this.performingRequest = true;
      fb.auth
        .createUserWithEmailAndPassword(
          this.signupForm.email,
          this.signupForm.password
        )
        .then((res) => {
          // createUserWithEmailAndPassword also resolves with a UserCredential
          this.$store.commit("setCurrentUser", res.user || fb.auth.currentUser);
          // let uid = use
          let ref = fb.profilesCollection.doc();
          ref
            .set({
              createdOn: new Date(),
              id: ref.id,
              uid: fb.auth.currentUser.uid,
              first: this.signupForm.first,
              last: this.signupForm.last,
              company: this.signupForm.company,
              role: this.signupForm.role,
              webrole: "user",
              group: "A",
              initial: this.initial,
              bio: this.signupForm.bio,
              email: this.signupForm.email,
            })
            .then((ref) => {
              console.warn(ref);
              this.$store.dispatch("fetchUserProfile");
              this.performingRequest = false;
              this.$router.push("/users/dashboard");
            })
            .catch((err) => {
              console.warn(err);
              this.performingRequest = false;
              this.errorMsg = err.message;
            });
        })
        .catch((err) => {
          console.warn(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
    resetPassword() {
      this.performingRequest = true;

      fb.auth
        .sendPasswordResetEmail(this.passwordForm.email)
        .then(() => {
          this.performingRequest = false;
          this.passwordResetSuccess = true;
          this.passwordForm.email = "";
        })
        .catch((err) => {
          console.warn(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
  },
};
</script>
